import { createContext, useContext, useState, useEffect, useMemo } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
const AdminAuthContext = createContext();

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const adminAxios = useMemo(() => {
    const instance = axios.create({ baseURL: API, withCredentials: true });
    instance.interceptors.response.use(
      (res) => res,
      (err) => {
        if (err.response?.status === 401) setAdmin(null);
        return Promise.reject(err);
      }
    );
    return instance;
  }, []);

  useEffect(() => {
    // Restore session from httpOnly cookie
    adminAxios.get("/admin/me")
      .then(({ data }) => setAdmin(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const adminLogin = (adminData) => setAdmin(adminData);

  const adminLogout = async () => {
    try { await adminAxios.post("/admin/logout"); } catch {}
    setAdmin(null);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, isAdminAuthenticated: !!admin, loading, adminLogin, adminLogout, adminAxios }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthContext);
